<template>
    <div :class="wrapperClass">
        <span v-html="message"></span>
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: "hint",
    props: ['message', 'hname'],
    computed: {
        wrapperClass() {
            return "hint-wrapper " + this.hname;
        }
    }
}
</script>

<style scoped lang="scss">
.hint-wrapper {
    color: #1A1A1A;
    font-size: 14px;
    background-color: #eeeeee6b;
    padding: 0.5em;
    border-radius: 4px;
    line-height: 24px;
    border: 1px solid #ddd7d7;
    word-break: break-word;
}
</style>